import Swiper from 'swiper';
import { Autoplay, Pagination, Navigation, Thumbs, Controller, FreeMode } from 'swiper/modules';
import 'swiper/css';

Swiper.use([Autoplay, Pagination, Navigation, Thumbs, Controller, FreeMode]);

// import $ from 'jquery';
// window.$ = window.jQuery = $;

import { Fancybox } from '@fancyapps/ui';

Fancybox.bind('[data-fancybox]', {
  animated: true,
  showClass: 'f-fadeIn',
  hideClass: 'f-fadeOut',
});

const heroslider = new Swiper('.heroslider-slider', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 16,
  centeredSlides: false,
  pagination: {
    el: '.heroslider__pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: '.heroslider-slider__next',
    prevEl: '.heroslider-slider__prev',
  },

  // breakpoints: {
  //   560: {
  //     spaceBetween: 24,
  //     slidesPerView: 2,
  //   },
  //   768: {
  //     spaceBetween: 32,
  //     slidesPerView: 3,
  //   },
  //   992: {
  //     slidesPerView: 4,
  //     spaceBetween: 40,
  //   },
  // },
});


const prod_slider = new Swiper('.prod-slider', {
  slidesPerView: 1,
  loop: false,
  spaceBetween: -20,
  centeredSlides: false,
  // pagination: {
  //   el: '.production__pagination',
  //   type: 'bullets',
  //   clickable: 'true',
  // },
  navigation: {
    nextEl: '.production-slider__next',
    prevEl: '.production-slider__prev',
  },

  breakpoints: {
    576: {
      spaceBetween: -20,
      slidesPerView: 2,
    },
    768: {
      spaceBetween: -20,
      slidesPerView: 4,
    },
    992: {
      spaceBetween: -20,
      slidesPerView: 7,
    },
  },
});

var previews = new Swiper('.single-project__smallthumbs .previewsslider', {
  spaceBetween: 8,
  slidesPerView: 2.33,
  freeMode: true,
  watchSlidesProgress: true,
  watchOverflow: true,
  observer: true,
  observeParents: true,

  breakpoints: {
    560: {
      spaceBetween: 24,
      slidesPerView: 2.33,
    },
    768: {
      spaceBetween: 12,
      slidesPerView: 3.33,
    },
    992: {
      slidesPerView: 4.33,
      spaceBetween: 16,
    },
  },
});

var fullimg = new Swiper('.single-project__bigthumb .albumslider', {
  loop: true,
  spaceBetween: 0,
  watchOverflow: true,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: '.single-project__smallthumbs .previewsslider__control_next',
    prevEl: '.single-project__smallthumbs .previewsslider__control_prev',
  },
});

function setActiveThumb(index) {
  previews.slides.forEach(function (slide, i) {
    slide.classList.toggle('is-active-thumb', i === index);
  });
}

// клик по превью -> двигаем главный
previews.on('click', function (swiper, event) {
  var clicked = swiper.clickedSlide;
  if (!clicked) return;
  var index = swiper.slides.indexOf(clicked);
  fullimg.slideToLoop(index);
});

// смена главного -> подсвечиваем нужное превью и докручиваем, только если оно не видно целиком
fullimg.on('slideChange', function () {
  var index = fullimg.realIndex;
  setActiveThumb(index);

  var visible = previews.visibleSlidesIndexes || [];
  if (visible.indexOf(index) === -1) {
    previews.slideTo(index, 300);
  }
});

// подсветка на старте
setActiveThumb(fullimg.realIndex);


document.addEventListener('DOMContentLoaded', () => {
  const btn = document.getElementById('blog-more');
  const list = document.getElementById('blog-cards');
  if (!btn || !list) return;

  let loading = false;

  btn.addEventListener('click', async () => {
    if (loading) return;
    loading = true;
    btn.disabled = true;
    btn.classList.add('is-loading');

    const body = new FormData();
    body.append('action', 'blog_load_more');
    body.append('offset', btn.dataset.offset);
    body.append('per_page', btn.dataset.perPage);

    try {
      const res = await fetch(btn.dataset.url, { method: 'POST', body });
      const json = await res.json();
      if (!json.success) throw new Error('Load more failed');

      list.insertAdjacentHTML('beforeend', json.data.html);
      btn.dataset.offset = Number(btn.dataset.offset) + json.data.count;

      if (!json.data.has_more) btn.closest('.blog__more').remove();
    } catch (e) {
      console.error(e);
    } finally {
      loading = false;
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  });
});


jQuery(function ($) {



  jQuery(function ($) {
    $('.mobile-menu').on('click', '.menu-item-has-children > a', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $item = $(this).closest('.menu-item');

      $item.toggleClass('is-open').children('.sub-menu').stop(true, true).slideToggle(250);
    });
  });




  $('.header__menubtn').on('click', function () {
    $('.header').toggleClass('header_mobileopen');
    $(this).toggleClass('header__menubtn_opened');
    $('body').toggleClass('scroll-lock');
  });



  $('.formwrap').on('click', '.submitform__close', function () {
    $('body').toggleClass('scroll-lock');
    $(this).closest('.formwrap').toggleClass('formwrap_visible');

    if ($('.formwrap').hasClass('formwrap_visible')) {
      $('.grecaptcha-badge').css('visibility', 'visible');
    } else {
      $('.grecaptcha-badge').css('visibility', 'hidden');
    }

  });


 $('.faq__item').on('click', '.faq__title', function () {

    const $item = $(this);
    const $desc = $item.closest('.faq__item').find('.faq__desc'); // скрытый блок
    const isOpened = $item.hasClass('opened'); // проверяем статус

    if (!isOpened) {
      // ОТКРЫВАЕМ
      $item.addClass('opened'); // 1. сразу ставим класс
      $desc.slideDown(300); // 2. выезжает
    } else {
      // ЗАКРЫВАЕМ
      $desc.slideUp(300, () => {
        // 1. заезжает
        $item.removeClass('opened'); // 2. убираем класс
      });
    }
  });

  jQuery(function ($) {
    const OPEN = 8 * 60; // 8:00 в минутах
    const CLOSE = 18 * 60; // 18:00
    const WORKDAYS = [1, 2, 3, 4, 5]; // пн–пт (0 — воскресенье)
    const DAY_NAMES = [
      'в воскресенье',
      'в понедельник',
      'во вторник',
      'в среду',
      'в четверг',
      'в пятницу',
      'в субботу',
    ];

    function plural(n, one, few, many) {
      const n10 = n % 10,
        n100 = n % 100;
      if (n10 === 1 && n100 !== 11) return one;
      if (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14)) return few;
      return many;
    }

    function getStatus() {
      // Москва: UTC+3 круглый год
      const msk = new Date(Date.now() + 3 * 3600 * 1000);
      const day = msk.getUTCDay();
      const mins = msk.getUTCHours() * 60 + msk.getUTCMinutes();
      const isWorkday = WORKDAYS.includes(day);

      if (isWorkday && mins >= OPEN && mins < CLOSE) {
        const left = CLOSE - mins;
        if (left >= 60) {
          const h = Math.floor(left / 60);
          return { open: true, text: `Сегодня ещё ${h} ${plural(h, 'час', 'часа', 'часов')}` };
        }
        return {
          open: true,
          text: `Сегодня ещё ${left} ${plural(left, 'минуту', 'минуты', 'минут')}`,
        };
      }

      if (isWorkday && mins < OPEN) {
        return { open: false, text: 'Откроемся сегодня в 8:00' };
      }

      // ищем ближайший рабочий день
      for (let i = 1; i <= 7; i++) {
        const next = (day + i) % 7;
        if (WORKDAYS.includes(next)) {
          const when = i === 1 ? 'завтра' : DAY_NAMES[next];
          return { open: false, text: `Откроемся ${when} в 8:00` };
        }
      }
    }

    function render() {
      const s = getStatus();
      $('.js-work-status')
        .text(s.text)
        .toggleClass('is-open', s.open)
        .toggleClass('is-closed', !s.open);
    }

    render();
    setInterval(render, 60 * 1000);
  });



});


/* =========================================================
   Правки квиза: удаление прикреплённого файла + маска телефона.
   Работает через делегирование — подхватит форму, даже если
   плагин отрисовывает её позже.
   ========================================================= */
(function () {
    const FORM = '.wpcf7-form';

    /* ---------- 2. Удаление прикреплённого файла ---------- */
    function syncRemoveButton(input) {
        const wrap = input.closest('.wpcf7-form-control-wrap') || input.parentNode;
        let btn = wrap.querySelector('.eesq-file-remove');

        if (input.files && input.files.length) {
            if (!btn) {
                btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'eesq-file-remove';
                btn.textContent = '× Удалить файл';
                wrap.appendChild(btn);
            }
        } else if (btn) {
            btn.remove();
        }
    }

    document.addEventListener('change', function (e) {
        if (e.target.matches(FORM + ' input[type="file"]')) {
            syncRemoveButton(e.target);
        }
    });

    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.eesq-file-remove');
        if (!btn) return;

        const wrap  = btn.closest('.wpcf7-form-control-wrap') || btn.parentNode;
        const input = wrap.querySelector('input[type="file"]');
        if (!input) return;

        input.value = '';
        syncRemoveButton(input);
    });

    // После успешной отправки CF7 сбрасывает форму — убираем кнопки
    document.addEventListener('wpcf7mailsent', function (e) {
        e.target.querySelectorAll('.eesq-file-remove').forEach(b => b.remove());
    });

    /* ---------- 3. Маска телефона +7 XXX XXX-XX-XX ---------- */
    function formatPhone(value) {
        let d = value.replace(/\D/g, '');
        if (!d) return '';

        if (d[0] === '8') d = '7' + d.slice(1);
        if (d[0] !== '7') d = '7' + d;
        d = d.slice(0, 11);

        let out = '+7';
        if (d.length > 1) out += ' ' + d.slice(1, 4);
        if (d.length > 4) out += ' ' + d.slice(4, 7);
        if (d.length > 7) out += '-' + d.slice(7, 9);
        if (d.length > 9) out += '-' + d.slice(9, 11);
        return out;
    }

    document.addEventListener('input', function (e) {
        const input = e.target;
        if (!input.matches(FORM + ' input[type="tel"]')) return;

        // Даём стереть «+7» целиком
        const digits = input.value.replace(/\D/g, '');
        if (e.inputType && e.inputType.startsWith('delete') && digits.length <= 1) {
            input.value = '';
            return;
        }

        input.value = formatPhone(input.value);
    });

    // Вставка из буфера: «8 (900) 123-45-67» → «+7 900 123-45-67»
    document.addEventListener('paste', function (e) {
        const input = e.target;
        if (!input.matches || !input.matches(FORM + ' input[type="tel"]')) return;

        e.preventDefault();
        const text = (e.clipboardData || window.clipboardData).getData('text');
        input.value = formatPhone(text);
        input.dispatchEvent(new Event('input', { bubbles: true }));
    });
})();


// Этапы работ: переключение для всех блоков .stages на странице
(() => {
    function openItem(item) {
        item.closest('.stages').querySelectorAll('.stages__item').forEach((other) => {
            const isOpen = other === item;
            other.classList.toggle('stages__item_opened', isOpen);
            other.querySelector(':scope > button')?.setAttribute('aria-expanded', String(isOpen));
            other.querySelector('.stages__item-full')?.setAttribute('aria-hidden', String(!isOpen));
        });
    }

    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('.stages__item > button, .stages__item-intro');
        if (!trigger) return;
        const item = trigger.closest('.stages__item');
        if (item && item.closest('.stages') && !item.classList.contains('stages__item_opened')) {
            openItem(item);
        }
    });
})();


document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('tz-popup');
  if (!popup) return;

  const FILE_TEXT = 'Прикрепить ТЗ';

  const sourceInput = popup.querySelector('input[name="source"]');
  const fileLabel = popup.querySelector('.tz-file');
  const fileInput = fileLabel?.querySelector('input[type="file"]');
  const fileText = fileLabel?.querySelector('.tz-file__text');
  const fileRemove = fileLabel?.querySelector('.tz-file__remove');

  /* ---------- Попап ---------- */

  const open = (trigger) => {
    if (sourceInput) {
      sourceInput.value = trigger ? trigger.textContent.trim() : 'Прямая ссылка';
    }
    popup.showModal();
    document.documentElement.classList.add('is-locked');
  };

  const close = () => popup.close();

  // Открытие: ссылки с #tz-popup (в т.ч. "/#tz-popup") и элементы с data-popup="tz"
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('a[href$="#tz-popup"], [data-popup="tz"]');
    if (!trigger) return;
    e.preventDefault();
    open(trigger);
  });

  // Закрытие: крестик или клик по подложке
  popup.addEventListener('click', (e) => {
    if (e.target === popup || e.target.closest('[data-popup-close]')) close();
  });

  popup.addEventListener('close', () => {
    document.documentElement.classList.remove('is-locked');
  });

  /* ---------- Файл ---------- */

  const updateFile = () => {
    if (!fileInput) return;
    const file = fileInput.files[0];
    if (fileText) fileText.textContent = file ? file.name : FILE_TEXT;
    fileLabel.classList.toggle('has-file', !!file);
  };

  const clearFile = () => {
    if (!fileInput) return;
    fileInput.value = '';
    updateFile();
    // убрать ошибку валидации CF7, если висела
    fileLabel.querySelector('.wpcf7-not-valid-tip')?.remove();
    fileInput.classList.remove('wpcf7-not-valid');
  };

  fileInput?.addEventListener('change', updateFile);

  fileRemove?.addEventListener('click', (e) => {
    e.preventDefault(); // чтобы клик не открыл выбор файла через label
    e.stopPropagation();
    clearFile();
  });

  /* ---------- CF7 ---------- */

  // После успешной отправки: сброс файла и закрытие через 3 сек
  popup.addEventListener('wpcf7mailsent', () => {
    clearFile();
    setTimeout(close, 3000);
  });

  /* ---------- Открытие по прямой ссылке site.ru/#tz-popup ---------- */

  if (location.hash === '#tz-popup') open(null);
});
